import { AlertTriangle } from 'lucide-react'

function DashboardEmptyState({ message }: { message: string }) {
  return (
    <div className="flex h-[180px] flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-primary/30 bg-gradient-to-br from-primary/5 to-secondary/5 p-6 text-center text-sm text-muted-foreground">
      <AlertTriangle className="h-6 w-6 text-primary" />
      <p>{message}</p>
      <p className="text-xs">Adjust filters or wait for new data.</p>
    </div>
  )
}

export default DashboardEmptyState
